import { render } from "./rrhh-collection-and-billing-section.vue?vue&type=template&id=acc210e2"
import script from "./rrhh-collection-and-billing-section.vue?vue&type=script&lang=js"
export * from "./rrhh-collection-and-billing-section.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__